import { baseState, baseMutations } from '@/store/mixins'
import student from '@/api/student-profile'
import studentTopfive from '@/api/student-top-five'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  getData (context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage
      },
      attributes
    )

    return studentTopfive.getData({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  async getStudent (context, attrubutes = {}) {
    let params = Object.assign(
      {
        fields: {
          setup_student_profiles:
            'student_id,card_number,first_name_en,last_name_en,gender,phone,date_of_birth,acps_id,promotion,level_id',
          sub_program: 'acps_id,acps_name_foreign',
          level: 'level_id,level_name_foreign'
        }
      },
      attrubutes
    )
    return await student.get({ params })
  }
}
